/* eslint-disable camelcase */
import axiosInstance from '../config/AxiosIntance'

function createJobPost({
  company_id,
  poc_id,
  title,
  target_comp_date,
  description,
  job_type,
  education,
  language,
  experience,
  certification,
  software,
  hardware_requirement,
  shift_availability,
  min_salary,
  max_salary,
  salary_basis,
  requires_coaching,
  active_vacancy,
  vacancy_for_pooling,
  time_shift,
  technical_skills,
  personal_skills,
  benefits,
  client,
  availability_to_start,
  recruiter_id,
  priority,
  countries,
  currencies,
  industry_id,
  second_interview_questions,
  recruitment_type_id,
  vacancy_type_id,
}) {
  return axiosInstance.post('/job', {
    company_id,
    poc_id,
    title,
    target_comp_date,
    description,
    job_type,
    education,
    language,
    time_shift,
    active_vacancy,
    vacancy_for_pooling,
    requires_coaching,
    certification,
    technical_skills,
    personal_skills,
    software,
    hardware_requirement,
    shift_availability,
    min_salary,
    max_salary,
    salary_basis,
    client,
    benefits,
    experience,
    recruiter_id,
    availability_to_start,
    priority,
    countries,
    currencies,
    industry_id,
    second_interview_questions,
    recruitment_type_id,
    vacancy_type_id,
  })
}

export default createJobPost
